"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _KPI = _interopRequireDefault(require("../elements/KPI"));
var _Spinner = _interopRequireDefault(require("../elements/Spinner"));
var _Block = _interopRequireDefault(require("../elements/Block"));
var _CoreProps = require("../utilities/CoreProps");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
class KPIList extends _react.default.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      isLoading: true
    };
  }
  componentDidMount() {
    const {
      getItems
    } = this.props;
    if (typeof getItems !== 'undefined') {
      getItems().then(data => {
        this.setState({
          items: data,
          isLoading: false
        });
      });
    }
  }
  render() {
    const {
      items,
      isLoading
    } = this.state;
    const {
      textFormatter,
      tooltips,
      children,
      getItems,
      className
    } = this.props;
    if (typeof getItems === 'undefined') {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "kpi--container"
      }, children);
    }
    if (isLoading) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: "is-full-width has-text-centered"
      }, /*#__PURE__*/_react.default.createElement(_Spinner.default, null));
    }
    const kpis = [];
    items.forEach(item => {
      const itemText = textFormatter(item);
      const toolTips = typeof tooltips === 'function' ? tooltips(items, item) : '';
      // let itemSize = toolTips !== null ? 'large' : 'small';
      // itemSize = itemSize === 'small' && item.title.length >= 19 ? 'medium' : itemSize;
      let itemSize = 'large';
      if (typeof item.size !== 'undefined') {
        itemSize = item.size;
      }
      if (itemText != null) {
        kpis.push( /*#__PURE__*/_react.default.createElement(_KPI.default, {
          className: itemSize,
          title: item.title,
          type: item.type,
          key: item.title,
          color: item.color
        }, itemText, toolTips));
      }
    });
    return /*#__PURE__*/_react.default.createElement(_Block.default, {
      className: className
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "kpi--container"
    }, kpis));
  }
}
KPIList.propTypes = {
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  getItems: _propTypes.default.func,
  textFormatter: _propTypes.default.func,
  tooltips: _propTypes.default.func,
  className: _propTypes.default.string
};
var _default = exports.default = (0, _CoreProps.withUiProps)(KPIList);
//# sourceMappingURL=KPIList.js.map